import { Grid } from "@mui/material";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import { useAuth } from "src/hooks/useAuth";
import { useDialog } from "src/context/DialogContext";
import { convertIntToCurrency } from "src/common";

import Button from "src/components/core/Button";
import InputText from "src/components/ui/InputText";
import Content from "src/components/ui/Content";
import Panel from "src/components/ui/Panel";
import {
  Desc,
  Line,
  Price,
  Section,
  TextSubTable,
  Title,
} from "src/modules/order/shipping-order/components";
import CustomerInfo from "src/modules/order/shipping-order/status-order/CustomerInfo";
import PurchaseInfo from "src/modules/order/shipping-order/status-order/PurchaseInfo";
import DocumentInfo from "src/modules/order/shipping-order/status-order/Document";
import ConfirmDialog from "src/modules/order/shipping-order/modal/ConfirmDialogDup";
import LocationDialog from "src/modules/order/shipping-order/modal/LocaltionDialog";
import Note from "src/modules/order/shipping-order/status-order/Note";

const ShippingDetail = ({ info, setIsLoading, callBackFetchInfo }) => {
  const { user, checkAllowPermission } = useAuth();
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const isAdmin = user?.role_id === 1;

  const isJSONString = (str) => {
    if (typeof str !== "string") return str;
    try {
      return JSON.parse(str);
    } catch {
      return str;
    }
  };

  return (
    <Grid container xs={12}>
      <Grid container xs={12} sx={{ mb: { xs: 2, md: 3 } }}>
        <Grid item xs={6}>
          <Title>รายละเอียดการจัดส่งสินค้า</Title>
        </Grid>

        {isAdmin && checkAllowPermission("orders.can_update_shippingOrder") && (
          <Grid item xs={6} display="flex" justifyContent={"flex-end"}>
            <Button
              variant="outlined"
              className="MuiButton-edit"
              startIcon={<ModeEditOutlinedIcon />}
              onClick={() => {
                openDialog({
                  type: "custom",
                  customDialog: (
                    <ConfirmDialog
                      orderDetail={info}
                      setIsLoading={setIsLoading}
                      onClose={() => closeDialog()}
                      onSuccess={() => {
                        closeAllDialogs();
                        callBackFetchInfo();
                      }}
                      isEdit
                    />
                  ),
                });
              }}
            >
              แก้ไข
            </Button>
          </Grid>
        )}
      </Grid>

      <Section
        borderBottom={
          isJSONString(info?.method) !== "ลูกค้ารับเอง" &&
          info?.fulfillmentProcess?.length === 1 &&
          info?.fulfillmentProcess[0]?.type !== "ไม่มีค่าจัดส่ง"
        }
      >
        <Grid item xs={12} sm={6} sx={{ pr: { xs: 0, sm: 1.5 } }}>
          <Grid item xs={12} mb={0.5}>
            <Desc>การจัดส่ง</Desc>
          </Grid>

          <Grid item xs={12}>
            <InputText
              disabled
              value={
                info?.status?.value === "failed"
                  ? "สินค้าไม่พร้อมจัดส่ง"
                  : "มีสินค้าพร้อมจัดส่ง"
              }
            />
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          sx={{ pl: { xs: 0, sm: 1.5 }, mt: { xs: 2, sm: 0 } }}
        >
          <Grid item xs={12} mb={0.5}>
            <Desc>รูปแบบการจัดส่ง</Desc>
          </Grid>

          <Grid item xs={12}>
            <InputText disabled value={isJSONString(info?.method)} />
          </Grid>
        </Grid>

        {info?.fulfillmentProcess.length > 1 ? (
          <>
            <Grid conaiter xs={12} mt={2}>
              <Desc primary>การส่งของที่ 1 (ร้านค้าส่งไปขนส่ง)</Desc>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ mt: { xs: 2 }, pr: { xs: 0, sm: 1.5 } }}
            >
              <Grid item xs={12} mb={0.5}>
                <Desc>ขนส่งที่ใช้ในการจัดส่ง</Desc>
              </Grid>

              {info?.fulfillmentProcess[0]?.carrier === "อื่นๆ" ? (
                <Grid container xs={12}>
                  <Grid item xs={4} pr={1}>
                    <InputText
                      disabled
                      value={info?.fulfillmentProcess[0]?.carrier}
                    />
                  </Grid>

                  <Grid item xs={8} pl={1}>
                    <InputText
                      disabled
                      value={info?.fulfillmentProcess[0]?.carrierAdditional}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <InputText
                    disabled
                    value={info?.fulfillmentProcess[0]?.carrier}
                  />
                </Grid>
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              sx={{ mt: { xs: 2 }, pl: { xs: 0, sm: 1.5 } }}
            >
              <Grid item xs={12} mb={0.5}>
                <Desc>ค่าจัดส่ง</Desc>
              </Grid>

              <Grid item xs={12}>
                <InputText
                  disabled
                  // value={
                  //   info?.fulfillmentProcess[0]?.type === "มีค่าจัดส่ง"
                  //     ? "มีค่าจัดส่ง"
                  //     : info?.fulfillmentProcess[0]?.type === "ไม่มีค่าจัดส่ง"
                  //       ? "ไม่มีค่าจัดส่ง"
                  //       : "เก็บเงินปลายทาง"
                  // }
                  value={info?.fulfillmentProcess[0]?.type}
                />
              </Grid>
            </Grid>

            <Grid conaiter xs={12} mt={2}>
              <Desc primary>การส่งของที่ 2 (ขนส่งส่งไปลูกค้า)</Desc>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ mt: { xs: 2 }, pr: { xs: 0, sm: 1.5 } }}
            >
              <Grid item xs={12} mb={0.5}>
                <Desc>ขนส่งที่ใช้ในการจัดส่ง</Desc>
              </Grid>

              {info?.fulfillmentProcess[1]?.carrier === "อื่นๆ" ? (
                <Grid container xs={12}>
                  <Grid item xs={4} pr={1}>
                    <InputText
                      disabled
                      value={info?.fulfillmentProcess[1]?.carrier}
                    />
                  </Grid>

                  <Grid item xs={8} pl={1}>
                    <InputText
                      disabled
                      value={info?.fulfillmentProcess[1]?.carrierAdditional}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <InputText
                    disabled
                    value={info?.fulfillmentProcess[1]?.carrier}
                  />
                </Grid>
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              sx={{ mt: { xs: 2 }, pl: { xs: 0, sm: 1.5 } }}
            >
              <Grid item xs={12} mb={0.5}>
                <Desc>ค่าจัดส่ง</Desc>
              </Grid>

              <Grid item xs={12}>
                <InputText
                  disabled
                  // value={
                  //   info?.fulfillmentProcess[1]?.type === "มีค่าจัดส่ง"
                  //     ? "มีค่าจัดส่ง"
                  //     : info?.fulfillmentProcess[1]?.type === "ไม่มีค่าจัดส่ง"
                  //       ? "ไม่มีค่าจัดส่ง"
                  //       : "เก็บเงินปลายทาง"
                  // }
                  value={info?.fulfillmentProcess[1]?.type}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sx={{ mt: { xs: 2 } }}>
              <Grid item xs={12} mb={0.5}>
                <Desc>หมายเหตุ</Desc>
              </Grid>

              <Grid item xs={12}>
                <InputText
                  disabled
                  value={info?.fulfillmentProcess[1]?.remark ?? "-"}
                />
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            {isJSONString(info?.method) !== "ลูกค้ารับเอง" ? (
              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ mt: { xs: 2 }, pr: { xs: 0, sm: 1.5 } }}
                >
                  <Grid item xs={12} mb={0.5}>
                    <Desc>ขนส่งที่ใช้ในการจัดส่ง</Desc>
                  </Grid>

                  {info?.fulfillmentProcess[0]?.carrier === "อื่นๆ" ? (
                    <Grid container xs={12}>
                      <Grid item xs={4} pr={1}>
                        <InputText
                          disabled
                          value={info?.fulfillmentProcess[0]?.carrier}
                        />
                      </Grid>

                      <Grid item xs={8} pl={1}>
                        <InputText
                          disabled
                          value={info?.fulfillmentProcess[0]?.carrierAdditional}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <InputText
                        disabled
                        value={info?.fulfillmentProcess[0]?.carrier}
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ mt: { xs: 2 }, pl: { xs: 0, sm: 1.5 } }}
                >
                  <Grid item xs={12} mb={0.5}>
                    <Desc>ค่าจัดส่ง</Desc>
                  </Grid>

                  <Grid item xs={12}>
                    <InputText
                      disabled
                      // value={
                      //   info?.fulfillmentProcess[0]?.type === "มีค่าจัดส่ง"
                      //     ? "มีค่าจัดส่ง"
                      //     : info?.fulfillmentProcess[0]?.type ===
                      //         "ไม่มีค่าจัดส่ง"
                      //       ? "ไม่มีค่าจัดส่ง"
                      //       : "เก็บเงินปลายทาง"
                      // }
                      value={info?.fulfillmentProcess[0]?.type}
                    />
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ pr: { xs: 0, sm: 1.5 } }}
                  mt={2}
                >
                  <Grid item xs={12} mb={0.5}>
                    <Desc>ที่อยู่ร้านค้า</Desc>
                  </Grid>

                  <Grid item xs={12}>
                    <InputText
                      disabled
                      value={
                        info?.fulfillmentProcess[0]?.pickupAddress?.address
                      }
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ pl: { xs: 0, sm: 1.5 } }}
                  mt={2}
                >
                  <Grid item xs={12} mb={0.5}>
                    <Desc>เบอร์ติดต่อ</Desc>
                  </Grid>

                  <Grid item xs={12}>
                    <InputText
                      disabled
                      value={info?.fulfillmentProcess[0]?.pickupAddress?.tel}
                    />
                  </Grid>
                </Grid>

                <Grid container xs={12} sx={{ mt: { xs: 2} }}>
                  <Button
                    variant="outlined"
                    className="MuiButton-location"
                    // startIcon={}
                    onClick={() =>
                      openDialog({
                        type: "custom",
                        customDialog: (
                          <LocationDialog
                            info={info}
                            onClose={() => closeDialog()}
                          />
                        ),
                      })
                    }
                    width={"300px"}
                  >
                    <LocationOnIcon fontSize="small" />
                    ดูหมุด Location
                  </Button>

                   <Button
                    variant="outlined"
                    className="MuiButton-location-google-maps"
                    onClick={() =>
                      window.open(`https://www.google.com/maps?q=${info?.fulfillmentProcess[0]?.pickupAddress?.coordinates?.lat},${info?.fulfillmentProcess[0]?.pickupAddress?.coordinates?.lng}`, '_blank')
                    }
                  >
                    <LocationOnIcon fontSize="small" />
                    ดูหมุดบน Google Maps
                  </Button>
                </Grid>
              </>
            )}

            <Grid item xs={12} sx={{ mt: { xs: 2 } }}>
              <Grid item xs={12} mb={0.5}>
                <Desc>หมายเหตุ</Desc>
              </Grid>

              <Grid item xs={12}>
                <InputText
                  disabled
                  value={info?.fulfillmentProcess[0]?.remark ?? "-"}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Section>

      {info?.fulfillmentProcess[0]?.type === "เก็บเงินปลายทาง" && (
        <>
          <Grid container xs={12} sx={{ mt: { xs: 2, md: 3 } }}>
            <Grid item xs={8} display="flex" justifyItems="flex-end">
              <Title>ค่าจัดส่งโดยประมาณ (เก็บเงินปลายทาง)</Title>
            </Grid>

            <Grid
              item
              xs={4}
              display="flex"
              justifyContent="flex-end"
              sx={{ alignItems: { xs: "baseline" } }}
            >
              <Price>
                {convertIntToCurrency(info?.fulfillmentProcess[0]?.shippingFee)}
              </Price>

              <Desc>บาท</Desc>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <TextSubTable>
              *เพื่อแจ้งให้ลูกค้าเตรียมเงินและทราบค่าจัดส่งโดยประมาณ
            </TextSubTable>
          </Grid>
        </>
      )}

      {isJSONString(info?.method) !== "ลูกค้ารับเอง" && (
        <>
          {info?.fulfillmentProcess[0]?.type === "มีค่าจัดส่ง" ||
          info?.fulfillmentProcess[1]?.type === "มีค่าจัดส่ง" ? ( // Show payment details only if there is a shipping fee
            <>
              <Grid containe sx={{ mt: { xs: 2, md: 3 } }}>
                <Title>ช่องทางการชำระเงิน</Title>
              </Grid>

              <Section borderBottom>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ pr: { xs: 0, sm: 1.5 }, mt: { xs: 2, sx: 0 } }}
                >
                  <Grid item xs={12} mb={0.5}>
                    <Desc>ชื่อบัญชี</Desc>
                  </Grid>

                  <Grid item xs={12}>
                    <InputText
                      disabled
                      value={info?.payment?.info?.bankAccountName}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ pl: { xs: 0, sm: 1.5 }, mt: { xs: 2, sx: 0 } }}
                >
                  <Grid item xs={12} mb={0.5}>
                    <Desc>เลขที่บัญชี</Desc>
                  </Grid>

                  <Grid item xs={12}>
                    <InputText disabled value={info?.payment?.info?.bankNo} />
                  </Grid>
                </Grid>
              </Section>

              <Grid container>
                <Grid item xs={12} sx={{ mt: { xs: 2, md: 3 } }}>
                  <Title>ค่าจัดส่งเพิ่มเติม</Title>
                </Grid>

                {info?.fulfillmentProcess.length > 1 ? (
                  <>
                    {info?.fulfillmentProcess[0]?.type === "มีค่าจัดส่ง" && (
                      <Grid container xs={12} sx={{ mt: { xs: 1, md: 2 } }}>
                        <Grid item xs={9}>
                          <Desc>
                            ค่าจัดส่ง (การส่งของที่ 1 (ร้านค้าส่งไปขนส่ง))
                          </Desc>
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          display="flex"
                          justifyContent="flex-end"
                        >
                          <Desc>{`${convertIntToCurrency(info?.fulfillmentProcess[0]?.shippingFee)} บาท`}</Desc>
                        </Grid>
                      </Grid>
                    )}

                    {info?.fulfillmentProcess[1]?.type === "มีค่าจัดส่ง" ||
                    (info?.fulfillmentProcess[0]?.type === "มีค่าจัดส่ง" &&
                      info?.fulfillmentProcess[1]?.type ===
                        "เก็บเงินปลายทาง") ? (
                      <Grid container xs={12} sx={{ mt: { xs: 1, md: 1 } }}>
                        <Grid item xs={9}>
                          <Desc>
                            ค่าจัดส่ง (การส่งของที่ 2 (ขนส่งส่งไปลูกค้า))
                          </Desc>
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          display="flex"
                          justifyContent="flex-end"
                        >
                          <Desc>{`${convertIntToCurrency(info?.fulfillmentProcess[1]?.shippingFee)} บาท`}</Desc>
                        </Grid>
                      </Grid>
                    ) : null}

                    <Grid container xs={12} sx={{ mt: { xs: 1, md: 2 } }}>
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        alignItems="flex-end"
                        sx={{ mb: { xs: 0, sm: 2 } }}
                        // mb={2}
                      >
                        <Title>ยอดชำระ</Title>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        justifyContent="flex-end"
                        sx={{ alignItems: { xs: "baseline" } }}
                      >
                        {(info?.fulfillmentProcess[0]?.type === "มีค่าจัดส่ง" &&
                          info?.fulfillmentProcess[1]?.type ===
                            "มีค่าจัดส่ง") ||
                        (info?.fulfillmentProcess[0]?.type === "มีค่าจัดส่ง" &&
                          info?.fulfillmentProcess[1]?.type ===
                            "เก็บเงินปลายทาง") ? (
                          <Price>
                            {`${convertIntToCurrency(info?.fulfillmentProcess[0]?.shippingFee + info?.fulfillmentProcess[1]?.shippingFee)} `}
                          </Price>
                        ) : info?.fulfillmentProcess[0]?.type ===
                          "มีค่าจัดส่ง" ? (
                          <Price>
                            {`${convertIntToCurrency(info?.fulfillmentProcess[0]?.shippingFee)} `}
                          </Price>
                        ) : info?.fulfillmentProcess[1]?.type ===
                          "มีค่าจัดส่ง" ? (
                          <Price>
                            {`${convertIntToCurrency(info?.fulfillmentProcess[1]?.shippingFee)} `}
                          </Price>
                        ) : null}

                        <Desc>บาท</Desc>
                      </Grid>
                    </Grid>

                    {info?.fulfillmentProcess[0]?.type === "มีค่าจัดส่ง" &&
                      info?.fulfillmentProcess[1]?.type ===
                        "เก็บเงินปลายทาง" && (
                        <>
                          <Line />

                          <Grid container xs={12} sx={{ mt: { xs: 2, md: 0 } }}>
                            <Grid
                              item
                              xs={8}
                              display="flex"
                              justifyItems="flex-end"
                            >
                              <Title>
                                ค่าจัดส่งโดยประมาณ (เก็บเงินปลายทาง)
                              </Title>
                            </Grid>

                            <Grid
                              item
                              xs={4}
                              display="flex"
                              justifyContent="flex-end"
                            >
                              <Price>
                                {convertIntToCurrency(
                                  info?.fulfillmentProcess[1]?.shippingFee,
                                )}
                              </Price>

                              <Desc>บาท</Desc>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <TextSubTable>
                              *เพื่อแจ้งให้ลูกค้าเตรียมเงินและทราบค่าจัดส่งโดยประมาณ
                            </TextSubTable>
                          </Grid>
                        </>
                      )}
                  </>
                ) : (
                  <>
                    <Grid container xs={12} sx={{ mt: { xs: 1, md: 3 } }}>
                      <Grid item xs={6}>
                        <Desc>ค่าจัดส่ง</Desc>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Desc>{`${convertIntToCurrency(info?.fulfillmentProcess[0]?.shippingFee)} บาท`}</Desc>
                      </Grid>
                    </Grid>

                    <Grid container xs={12} sx={{ mt: { xs: 1, md: 2 } }}>
                      <Grid item xs={6} display="flex" alignItems="flex-end">
                        <Title>ยอดชำระ</Title>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Price>
                          {`${convertIntToCurrency(info?.fulfillmentProcess[0]?.shippingFee)} `}
                        </Price>

                        <Desc>บาท</Desc>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </>
          ) : info?.fulfillmentProcess[0]?.type === "ไม่มีค่าจัดส่ง" &&
            info?.fulfillmentProcess[1]?.type === "เก็บเงินปลายทาง" ? ( // Show shipping fee only if the first process has no shipping fee and the second has cash on delivery
            <>
              <Grid
                container
                sx={{
                  mt: { xs: 2, md: 3 },
                }}
              >
                <Grid item xs={8} display="flex" justifyItems="flex-end">
                  <Title>ค่าจัดส่งโดยประมาณ (เก็บเงินปลายทาง)</Title>
                </Grid>

                <Grid
                  item
                  xs={4}
                  display="flex"
                  justifyContent="flex-end"
                  sx={{ alignItems: { xs: "baseline" } }}
                >
                  <Price>
                    {convertIntToCurrency(
                      info?.fulfillmentProcess[1]?.shippingFee,
                    )}
                  </Price>

                  <Desc>บาท</Desc>
                </Grid>

                <Grid item xs={12}>
                  <TextSubTable>
                    *เพื่อแจ้งให้ลูกค้าเตรียมเงินและทราบค่าจัดส่งโดยประมาณ
                  </TextSubTable>
                </Grid>
              </Grid>
            </>
          ) : info?.fulfillmentProcess[0]?.type === "โดย Xsurface" ? (
            <>
              <Grid container>
                <Grid item xs={12} sx={{ mt: { xs: 2, md: 3 } }}>
                  <Title>ค่าจัดส่งเพิ่มเติม</Title>
                </Grid>

                <Grid item xs={12} container sx={{ mt: { xs: 1, md: 2 } }}>
                  <Grid item xs={6}>
                    <Desc>ค่าจัดส่ง Lalamove</Desc>
                  </Grid>

                  {/* shipping fee from lalamove + 100 */}
                  <Grid item xs={6} display="flex" justifyContent="flex-end">
                    <Desc>{`${convertIntToCurrency(info?.fulfillmentProcess[0]?.lalamoveCheck?.result?.totalWithFee)} บาท`}</Desc>
                  </Grid>
                </Grid>

                {/* only admin can view additional payment amount  */}
                {isAdmin && (
                  <>
                    <Grid item xs={12} container sx={{ mt: 1 }}>
                      <Grid item xs={6}>
                        <Desc>ยอดชำระเพิ่มเติม</Desc>
                      </Grid>

                      {/* if 800 < (shipping fee from lalamove + 100) <= 820 = 0
                        else if (shipping fee from lalamove + 100) > 820 = (shipping fee from lalamove + 100) - 800 */}
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Desc>{`${convertIntToCurrency(info?.fulfillmentProcess[0]?.lalamoveCheck?.result?.totalWithDiscount)} บาท`}</Desc>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container sx={{ mt: 1 }}>
                      <Grid item xs={6}>
                        <Desc>ภาษีมูลค่าเพิ่ม</Desc>
                      </Grid>

                      {/* vat 7% of totalWithDiscount */}
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Desc>{`${convertIntToCurrency(info?.fulfillmentProcess[0]?.lalamoveCheck?.result?.shippingVat || 0)} บาท`}</Desc>
                      </Grid>
                    </Grid>

                    <Grid item container xs={12} sx={{ mt: { xs: 1, md: 2 } }}>
                      <Grid item xs={6} display="flex" alignItems="flex-end">
                        <Title>ยอดเรียกชำระเพิ่มเติม</Title>
                      </Grid>

                      {/* totalWithDiscount + vat 7% || totalWithDiscount (if not have in old version) */}
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Price>
                          {`${convertIntToCurrency(info?.fulfillmentProcess[0]?.lalamoveCheck?.result?.totalWithDiscountWithVat || info?.fulfillmentProcess[0]?.lalamoveCheck?.result?.totalWithDiscount)} `}
                        </Price>

                        <Desc>บาท</Desc>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </>
          ) : (
            info?.fulfillmentProcess[0]?.type !== "เก็บเงินปลายทาง" &&
            info?.fulfillmentProcess[0]?.type !== "ไม่มีค่าจัดส่ง" && ( // Show other shipping fee types
              <>
                <Grid
                  container
                  xs={12}
                  sx={{
                    mt: { xs: 2, md: 3 },
                  }}
                >
                  <Grid item xs={8} display="flex" justifyItems="flex-end">
                    <Title>ค่าจัดส่งโดยประมาณ (เก็บเงินปลายทาง)</Title>
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    display="flex"
                    justifyContent="flex-end"
                    sx={{ alignItems: { xs: "baseline" } }}
                  >
                    <Price>
                      {convertIntToCurrency(
                        info?.fulfillmentProcess[1]?.shippingFee,
                      )}
                    </Price>

                    <Desc>บาท</Desc>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <TextSubTable>
                    *เพื่อแจ้งให้ลูกค้าเตรียมเงินและทราบค่าจัดส่งโดยประมาณ
                  </TextSubTable>
                </Grid>
              </>
            )
          )}
        </>
      )}
    </Grid>
  );
};

const Confirmed = ({ info, callbackCloseDocument, setIsLoading }) => {
  return (
    <>
      <Content>
        <Panel>
          <CustomerInfo info={info} />
        </Panel>

        <Panel>
          <PurchaseInfo info={info.order} />
        </Panel>

        <Panel>
          <ShippingDetail
            info={info}
            setIsLoading={setIsLoading}
            callBackFetchInfo={callbackCloseDocument}
          />
        </Panel>

        <Panel>
          <DocumentInfo
            info={info}
            isCloseDialog={callbackCloseDocument}
            setIsLoading={setIsLoading}
          />
        </Panel>

        <Panel>
          <Note info={info?.order} />
        </Panel>
      </Content>
    </>
  );
};

export default Confirmed;
